import React, { useEffect, useState } from "react";
import { IoLocationSharp, IoBriefcase } from "react-icons/io5";
import { BsCurrencyDollar, BsStarFill } from "react-icons/bs";
import { FaDollarSign } from "react-icons/fa";
import { HiClock } from "react-icons/hi";
import {
ConsoleSqlOutlined,
HeartFilled,
StarOutlined } from
"@ant-design/icons";
import { BsFillEyeFill } from "react-icons/bs";
import {
Row,
Col,
Card,
Avatar,
Rate,
Tag,
Skeleton,
Typography,
Checkbox,
Tooltip } from
"antd";
import history from "../../../../routes/history";
import Frame from "../../../../assets/img/Top_rated@2x.svg";
import ex_suitcase from "../../../../assets/icons/ex_suitcase.png";
import { useDispatch } from "react-redux";
import moment from "moment";
import { Link } from "react-router-dom";
import { getImage } from "../../../../utilities/storageOperations/downloadURL";
import TopAlert from "../../../../components/TopNotification/TopAlert";
import { clearUserSkillListing } from "../../../../redux/actions";import { isNonHC } from "../../../../shared/helpers";

const MatchesGigsCard = React.memo((props) => {
  const { Meta } = Card;
  const { Text } = Typography;
  const dispatch = useDispatch();
  const [selectCardsMsg, setSelectCardsMsg] = useState(false);
  const list_index = props?.totaldata?.findIndex((item) =>
  item.skill_listing ?
  item.skill_listing._id == props.skill_listing._id :
  item._id == props._id);

  const [checked, setChecked] = React.useState(
  props?.checkAll ? props.checkAll[list_index] : null);

  const [profilePic, setProfilePic] = React.useState();
  const [isChecked, setIsChecked] = React.useState(false);
  const [imageError, setImageError] = useState(false);
  let stars =
  props?.user?.Accounts?.Rating == 0 ||
  props?.user?.Accounts?.Rating == null ||
  props?.user?.Accounts?.Rating == undefined ?
  3.5 :
  parseFloat(props?.user?.Accounts?.Rating);
  const detailsPage = () => {
    dispatch(clearUserSkillListing());
  };
  const [dimensions, setDimensions] = useState(window.innerWidth);
  const professionCode = JSON.parse(localStorage.getItem("userProfile"));

  const checkDimensions = () => {
    setDimensions(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", checkDimensions);
  }, []);

  useEffect(() => {
    if (!props.selectedCandidates.length) {
      setIsChecked(false);
    }
  }, [props.selectedCandidates]);

  useEffect(() => {
    setTimeout(() => {
      setSelectCardsMsg(false);
    }, 4000);
  }, [selectCardsMsg]);

  const onCheckChangeCard = () => {
    if (props?.checkAllDataAll?.length) {
      if (isChecked) {
        setIsChecked(false);
        props.setCheckAllDataAll((previous) => previous.filter((prev) => prev.skill_listing.SkillListingId != props._id));
        props.setSelectedCandidates((prev) => prev.filter((previous) => previous != props?._id));
      } else
      if (!isChecked) {
        setIsChecked(true);
        props.setCheckAllDataAll((prev) => [...prev, props.skillListObj]);
        props.setSelectedCandidates((prev) => [...prev, props?._id]);
      }
    } else {
      if (isChecked) {
        setIsChecked(false);
        props.setCheckAllDataAll([]);
      } else {
        setIsChecked(true);
        props.setCheckAllDataAll((prev) => [...prev, props.skillListObj]);
        props.setSelectedCandidates((prev) => [...prev, props?._id]);
      }
    }
  };

  useEffect(() => {
    let check = false;
    props?.checkAllDataAll && props?.checkAllDataAll.length && props?.checkAllDataAll?.map((item) => {
      if (item?.skill_listing?.SkillListingId == props._id) {
        check = true;
      }
    });

    setIsChecked(check);

    // if (props.checkAllDataAll) {
    //   if (
    //     props.checkAllDataAll?.find(
    //       (skillListingObj) => skillListingObj == props._id
    //     )
    //   ) {
    //     setIsChecked(true);
    //   } else {
    //     setIsChecked(false);
    //   }
    // }

    // if (props.checkAllData) {
    //   props.checkAllData?.map((item) => {
    //     if (item.index == props.index) {
    //       if (
    //         item?.ids.find(
    //           (skillListingObj) =>
    //             skillListingObj.skill_listing?.SkillListingId == props._id
    //         )
    //       ) {
    //         setIsChecked(true);
    //       } else {
    //         if (
    //           props.selectedCandidates?.find(
    //             (items) => items.skill_listing?.SkillListingId == props._id
    //           )
    //         ) {
    //           return;
    //         } else {
    //           setIsChecked(false);
    //         }
    //       }
    //     }
    //   });
    // }
  }, [props.checkAllDataAll, props.checkAllData]);

  // const onCheckChangeCard = () => {

  //   if (props.checkAllDataAll != null) {
  //     var test = props.checkAllDataAll;

  //     if (isChecked) {
  //       var newItemIds = test?.ids.filter(
  //         (skillListingObj) => skillListingObj != props?._id
  //       );

  //       let prevIds = [];

  //       prevIds = props?.selectedCandidates;
  //       const newIdArray = prevIds.filter((item) => item != props?._id);
  //       test.ids = newItemIds;
  //       test.checked = false;
  //       props.setcheckAllCandidate(false);
  //       props.setCheckAllDataAll([]);
  //       // props?.setSelectedCandidates(newItemIds)

  //       // props?.setSelectedCandidates(
  //       //   props?.selectedCandidates?.filter((item)=>
  //       //     item != props?._id

  //       // ))

  //       props?.setSelectedCandidates(newIdArray);
  //       // var newSelectedCandidates = props.selectedCandidates?.filter(
  //       //   (skillListingObj) =>
  //       //     skillListingObj?.skill_listing?.SkillListingId != props?._id
  //       // );
  //       // props.setSelectedCandidates([]);
  //     } else {
  //       // if (props.selectedCandidates.length >= 10) {
  //       //   setSelectCardsMsg(true);
  //       //   return;
  //       // }
  //       var newItemIds = test?.ids;
  //       let prevIds = [];
  //       let newIdCheck = false;
  //       prevIds = props?.selectedCandidates;
  //       newItemIds = [...newItemIds, props.skillListObj];
  //       test.ids = newItemIds;

  //       if (test.ids.length == test.total_ids) {
  //         test.checked = true;
  //         props.setcheckAllCandidate(true);
  //       }

  //       prevIds?.map((item) => {
  //         if (item != props._id) {
  //           newIdCheck = true;
  //         }
  //       });

  //       if (newIdCheck || prevIds?.length === 0) {
  //         // const newID = prevIds.push(props?._id)
  //         props?.setSelectedCandidates([
  //           ...props?.selectedCandidates,
  //           props?._id,
  //         ]);
  //       }

  //       // var newSelectedCandidates = [
  //       //   ...props.selectedCandidates,
  //       //   props.skillListObj,
  //       // ];
  //       // props?.setSelectedCandidates([...props?.selectedCandidates, props?._id])
  //       props.setCheckAllDataAll([]);
  //     }

  //     // props.setSelectedCandidates(test.ids);
  //     props.setCheckAllDataAll(test);
  //     setIsChecked((prevCheck) => !prevCheck);
  //   }

  //   if (props.checkAllData != null) {
  //     var test = props?.checkAllData;
  //     var item_index = test.findIndex((object) => {
  //       return object.index === props.index;
  //     });

  //     if (isChecked) {
  //       test?.map((item) => {
  //         if (item.index == props.index) {
  //           var newItemIds = item?.ids.filter(
  //             (skillListingObj) => skillListingObj != props?._id
  //           );

  //           test[item_index].ids = newItemIds;

  //           test[item_index].checked = false;
  //         }
  //       });

  //       var ar = props.checkedBoxes.filter((item) => item != props.index);
  //       props.setCheckedBoxes(ar);

  //       props.setCheckAllData([]);

  //       var newSelectedCandidates = props.selectedCandidates?.filter(
  //         (skillListingObj) =>
  //           skillListingObj?.skill_listing?.SkillListingId != props?._id
  //       );
  //       // props.setSelectedCandidates([]);
  //     } else {
  //       // if (props.selectedCandidates.length >= 10) {
  //       //   setSelectCardsMsg(true);
  //       //   return;
  //       // }
  //       test?.map((item) => {
  //         if (item.index == props.index) {
  //           var newItemIds = item?.ids;
  //           newItemIds = [...newItemIds, props.skillListObj];
  //           test[item_index].ids = newItemIds;
  //         }
  //       });

  //       if (test[item_index]?.ids?.length == test[item_index]?.total_ids) {
  //         test?.map((item) => {
  //           if (item.index == props.index) {
  //             test[item_index].checked = true;
  //           }
  //         });
  //         props.setCheckedBoxes([...props.checkedBoxes, props.index]);
  //       }

  //       var newSelectedCandidates = [
  //         ...props.selectedCandidates,
  //         props.skillListObj,
  //       ];
  //       props.setCheckAllData([]);
  //     }

  //     // props.setSelectedCandidates(newSelectedCandidates);
  //     props.setCheckAllData(test);
  //     setIsChecked((prevCheck) => !prevCheck);
  //   }
  // };

  useEffect(async () => {
    let profilePic = '';
    if (props?.user) {
      if (props?.user?.Accounts?.PictureUrl) {
        profilePic = await getImage(props?.user?.Accounts?.PictureUrl);
      } else
      {
        profilePic = await getImage(props?.PictureUrl);
      }
      setProfilePic(profilePic);
    } else
    {
      profilePic = await getImage(props?.PictureUrl);
    }
  }, [props]);
  // console.log("jmhngfds",props.candidateName);
  // console.log("jmhngfds 1",props.user?.Accounts?.FirstName);


  return (
    <React.Fragment>
      {/* {selectCardsMsg && (
          <TopAlert
            display={"flex"}
            title={
              "You have reached the maximum limit of 10 for placing the bids at once "
            }
            type="warning"
          />
         )} */}

      <Link
      to={{
        pathname: `/profiledetail/${props._id}`,
        state: {
          id: props._id,
          token: props.token,
          fromMatches: true,
          jobId: props.jobId,
          JobTitle: props.job_title,
          jobdetails: props.jobdetails
        },
        search: `matches=true&jobId=${props.jobId}&skillid=${props._id}`
      }}>
        
        <div
        className="skill-thecard"
        onClick={detailsPage}
        style={{
          width: "100%"
        }}>
          
          <Row className={"cards-top-row"}>
            <div style={{ position: "absolute" }}>
              {props.token != null && !props.bidstatus && !props?.bidPlaced ?
              <Checkbox
              className="checkboxes"
              onClick={(e) => e.stopPropagation()}
              onChange={() => onCheckChangeCard()}
              checked={isChecked}
              key={props._id}
              //  value={props.users}
              /> :
              null}
            </div>
            <div style={{ margin: "auto" }}>
              <div
              className={
              props.token == null ?
              "image-circle-container-guest" :
              "image-circle-container"}>

                
                <div
                className={
                props.token != null ?
                "top-rated-vector" :
                "guestUser-vector-icon"}>

                  
                  {/* <img src={Frame} style={{ marginLeft: '0.5rem' }} /> */}
                </div>

                <div className="img-containerr">
                  {props?.user ?
                  props?.user?.Accounts?.PictureUrl &&
                  !imageError &&
                  props?.user?.Accounts?.PictureUrl?.split("/")?.pop() !==
                  "no-pic.png" ?
                  <img
                  className="profile-imagee"
                  alt=""
                  src={`${process.env.REACT_APP_S3_URL}${
                  props?.user?.Accounts?.PictureUrl?.charAt(0) !== "/" ?
                  "/" :
                  ""
                  }${props?.user?.Accounts?.PictureUrl}`}
                  onError={() => {
                    setImageError(true);
                  }} /> :


                  <div className="img-textt">
                        {props?.user?.Accounts?.FirstName ?
                    props.user?.Accounts?.FirstName.split(
                    "")[
                    0].toUpperCase() :
                    "C"}
                      </div> :

                  props && props?.user?.Accounts?.FirstName ?
                  <div className="img-textt">{`${props.user?.Accounts?.FirstName.split(
                    "")[
                    0].toUpperCase()}`}</div> :

                  <div className="img-textt">C</div>}
                  
                </div>
              </div>
            </div>
            <div
            style={{
              position: "absolute",
              right: "0",
              marginRight: "8px",
              fontSize: "17px"
            }}>
              
              {props.token != null && props.prevviewed ?
              <BsFillEyeFill style={{ color: "#7e7e7e", marginTop: "8px" }} /> :
              null}
              {props?.isViewed ?
              <BsFillEyeFill style={{ color: "#7e7e7e", marginTop: "8px" }} /> :
              null}
            </div>
          </Row>

          {/* <div> */}
          {props.candidateName ?
          <div className="container-meta">
              {props.candidateName &&
            props.candidateName != null &&
            props.candidateName != undefined &&
            props.candidateName != "" ?
            props.candidateName :
            "Candidate name"}
            </div> :

          <div className="container-meta">
              {props &&
            props.user &&
            props.user?.Accounts?.FirstName &&
            props.user?.Accounts?.FirstName != null &&
            props.user?.Accounts?.FirstName != undefined &&
            props.user?.Accounts?.FirstName != "" ?
            `${props.user?.Accounts?.FirstName}${" "}${
            props.user?.Accounts?.LastName
            }` :
            "Candidate name"}
            </div>}
          
          {/* </div> */}
          <div
          style={{
            textAlign: "center",
            lineHeight: "1.1",
            marginBottom: "7px"
          }}>
            
            <Rate
            className="rate-stars"
            value={stars}
            allowHalf
            disabled
            // defaultValue={stars}
            // defaultValue={props?.user?.Accounts?.Rating ? props?.user?.Accounts?.Rating : 3.5}
            />
            <Text className="rating-text">
              <span style={{ color: "#ffba08", fontSize: "12px" }}>
                {props?.user?.Accounts?.Rating ?? 3.5}
              </span>{" "}
              {props?.user?.Accounts?.Review > 0 &&
              `(${props?.user?.Accounts?.Review})`}
            </Text>
          </div>
          {props.skillTitle ?
          <Col className="skill-listing-title">
              <Tooltip title={props.skillTitle}>
                <div className="skill-Title-Detail">{props.skillTitle}</div>
              </Tooltip>
            </Col> :

          <Col className="skill-listing-title">
              <Tooltip title={props.Title}>
                <div className="skill-Title-Detail">{props.Title}</div>
              </Tooltip>
            </Col>}
          
          {
          // !isNonHC(professionCode?.Professions?.ProfessionCode) &&
          <Row className="desired-rate-div">
              <Col xs={24} className="desired-rate">
                {props.MinimumBid ?
              <div className="rate-value">
                    <Text className="desired-rate-text">
                      {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                  "Desired rate" :
                  "Est. Amount"}
                    </Text>{" "}
                    {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                props.MinimumBid ?
                "$" + props.MinimumBid :
                "$Negotiable" :
                props.ClientRate !== 0 ?
                "$" + props.ClientRate :
                "$Negotiable"}
                    {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                props.MinimumBidType ?
                "/" + (
                props.MinimumBidType === "Year" ?
                "YR" :
                props.MinimumBidType === "Hour" ?
                "HR" :
                "") :
                "" :
                props.ClientRate ?
                "/" + (
                props.MinimumBidType === "Year" ?
                "YR" :
                props.MinimumBidType === "Hour" ?
                "HR" :
                "") :
                ""}{" "}
                  </div> :

              <div className="rate-value">
                    <Text className="desired-rate-text">
                      {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                  "Desired rate" :
                  "Est. Amount"}
                    </Text>{" "}
                    {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                props.MinimumBid != null ?
                "$" + props.MinimumBid :
                "$Negotiable" :
                props.ClientRate != null ?
                "$" + props.ClientRate :
                "$Negotiable"}
                    {!isNonHC(professionCode?.Professions?.ProfessionCode) ?
                props.MinimumBidType ?
                "/" + (
                props.MinimumBidType === "Year" ?
                "YR" :
                props.MinimumBidType === "Hour" ?
                "HR" :
                "") :
                "" :
                props.ClientRate ?
                "/" + (
                props.MinimumBidType === "Year" ?
                "YR" :
                props.MinimumBidType === "Hour" ?
                "HR" :
                "") :
                ""}{" "}
                  </div>}
              
              </Col>
            </Row>}
          

          <Row
          className="Experience-row"
          style={{
            height: "2.6rem",
            width: "9rem",
            marginLeft: "auto",
            marginRight: "auto"
          }}>
            
            <Col lg={20} xs={24} className="experience">
              <img className="briefcase-img" src={ex_suitcase} alt="" />
              {props.ExperienceLevelName &&
              props.ExperienceLevelName != null &&
              props.ExperienceLevelName != "" &&
              props.ExperienceLevelName != undefined ?
              <Text style={{ marginLeft: "8px" }}>
                  {`${props.ExperienceLevelName} of experience`}
                </Text> :
              props?.user?.ExperienceLevelName &&
              props?.user?.ExperienceLevelName != null &&
              props?.user?.ExperienceLevelName != "" &&
              props?.user?.ExperienceLevelName != undefined ?
              <Text style={{ marginLeft: "8px" }}>
                  {`${props?.user?.ExperienceLevelName} of experience`}
                </Text> :

              <Text style={{ marginLeft: "8px" }}>N/A</Text>}
              
            </Col>
          </Row>
          {props?.LastSuccessfulLoginDate ?
          <div className={"last-active-text"}>
              {props?.LastSuccessfulLoginDate &&
            props.LastSuccessfulLoginDate != null ?
            "Last active " +
            moment(props?.LastSuccessfulLoginDate).fromNow() :
            "Last active N/A"}
            </div> :

          <div className={"last-active-text"}>
              {props?.user_Schema &&
            props.user_Schema?.profile.LastLoginDate != null ?
            "Last active " +
            moment(
            props.user?.Accounts?.LastSuccessfulLoginDate).
            fromNow() :
            "Last active N/A"}
            </div>}
          
        </div>
      </Link>
    </React.Fragment>);

});

export default MatchesGigsCard;